import { useFirstOrderIncentiveStore } from "@faire/retailer/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";

import { useAutoExtendText } from "./useAutoExtendText";
import { useGenericText } from "./useGenericText";
import { useVerticalizedFOITopBannerText } from "./useVerticalizedFOITopBannerText";

export const useBannerText = () => {
  const { isFirstOrderIncentiveAutoExtendEnabled, isLastChanceIncentive } =
    useFirstOrderIncentiveStore();
  const genericText = useGenericText();
  const autoExtendText = useAutoExtendText();
  const verticalizedText = useVerticalizedFOITopBannerText();

  const bannerText = () => {
    switch (true) {
      case isFirstOrderIncentiveAutoExtendEnabled:
        return autoExtendText;
      case isLastChanceIncentive:
        return verticalizedText;
      default:
        return genericText;
    }
  };

  return bannerText();
};
